export enum Country {
  AUSTRIA = 'AUSTRIA',
  GERMANY = 'GERMANY',
  SWITZERLAND = 'SWITZERLAND',
  DACH = 'DACH',
  ACH = 'ACH',
  DCH = 'DCH',
  AD = 'AD'
}
